import React, { useState, useEffect, useCallback } from 'react';
import { Close } from '../../assets/icons';
import { Input, Spinner } from '../../components';
import { Modal, ModalContent, ModalHeader, CloseButton, DisplayResults } from './partials';

// ✅ Definir debounce primero
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(null, args), wait);
  };
}

export const SongsFinder = ({ onClick }) => {
  const [showing, setShowing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [processingId, setProcessingId] = useState(null);

  // Función de búsqueda
  const searchSongs = async (title) => {
    if (!title.trim()) {
      setResults([]);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`https://api.juangutierreza.com/rj/spotify/search?q=${encodeURIComponent(title)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Manejo del límite de uso (429)
      if (res.status === 429) {
        const retryAfter = res.headers.get('Retry-After') || 5;
        console.warn(`Límite alcanzado. Reintentando en ${retryAfter} segundos...`);
        setTimeout(() => searchSongs(title), retryAfter * 1000);
        return;
      }

      const data = await res.json();
      setResults(data.songs || []);
    } catch (error) {
      console.error('Error en búsqueda:', error);
    } finally {
      setLoading(false);
    }
  };

  // Debounce de 500ms
  const debounceSearch = useCallback(
    debounce((value) => {
      searchSongs(value);
    }, 500),
    []
  );

  // Escucha cambios en el input
  useEffect(() => {
    debounceSearch(query);
  }, [query, debounceSearch]);

  const handleTrackClick = async (track) => {
    if (processingId) return; // Prevent double clicks

    setProcessingId(track.id);
    try {
      if (onClick) {
        await onClick(track);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <>
      <Input
        type="text"
        value={query}
        placeholder="Busca por título o artista"
        onChange={(value) => setQuery(value)}
        onFocus={() => setShowing(true)}
        fontSize={3}
        borderBottom
        marginTop={20}
        maxWidth="300px"
      />

      {showing && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <h2>Buscador de Canciones</h2>
              <CloseButton onClick={() => setShowing(false)}>
                <Close size={40} />
              </CloseButton>
            </ModalHeader>

            <Input
              style={{ color: 'var(--text2)' }}
              type="text"
              value={query}
              placeholder="Busca por título o artista"
              onChange={(value) => setQuery(value)}
              autoFocus
              borderBottom
            />

            <DisplayResults>
              {results.map((track) => (
                <div key={track.id} onClick={() => handleTrackClick(track)}>
                  {processingId === track.id ? (
                    <div style={{ width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Spinner size="30px" />
                    </div>
                  ) : (
                    <img src={track.image[2]?.url} alt={track.name} />
                  )}
                  <div style={{ opacity: processingId === track.id ? 0.5 : 1 }}>
                    <strong>{track.name}</strong> <br />
                    {track.artist} <br />
                  </div>
                </div>
              ))}
            </DisplayResults>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
